export default __webpack_public_path__ + "static/media/white_logotipo_i2sysbio_2017-6.2c18ff0c.png";